<button class="btn btn-success"
        (click)="createTransaction()"
>
    Создать транзакцию
</button>

<div>
    @for (transaction of allTransactions; track transaction.ps_transaction_key) {
        <div>
            <span>{{ transaction | json }}</span>
        </div>
    }
</div>
